import styled from '@emotion/styled'
import { isNumber } from 'lodash'
import { useGetUserCoin } from '../services/user/user-query'
import Card from './common/Card'
import Image from './common/Image'
import Text from './common/Text'
import iconCoin from '../assets/images/icons-coin-green-32-px.svg'
import { numberWithCommas } from '../utils/helper'

const CardPoint = styled(Card)`
  padding-top: 24px;
  padding-bottom: 24px;
  margin-top: 16px;
`
const FlexRowBaseLine = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: baseline;
`

const ImageStyle = styled(Image)`
  margin-left: 8px;
`

const TextPaddingLeft = styled(Text)`
  padding-left: 8px;
`

const TextCenter = styled(Text)`
  text-align: center;
`

const PointCard = () => {
  const { data: userCoin } = useGetUserCoin()
  return (
    <CardPoint>
      <FlexRowBaseLine>
        <ImageStyle width={32} height={32} src={iconCoin} />
        <TextPaddingLeft type="Bold" size={32} color="#005da7">
          {' '}
          {userCoin && isNumber(userCoin) ? numberWithCommas(Number(userCoin)) : 0}{' '}
        </TextPaddingLeft>
        <TextPaddingLeft type="SemiBold" size={18}>
          คะแนน
        </TextPaddingLeft>
      </FlexRowBaseLine>
      {/* <TextCenter type="SemiBold" size={18}>
        (คิดเป็นเงิน {userCoin && isNumber(userCoin) ? numberWithCommas(Number(userCoin)) : 0} บาท)
      </TextCenter> */}
    </CardPoint>
  )
}
export default PointCard
